/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".main-container[_ngcontent-%COMP%]{min-height:95%;padding-top:140px}@media (min-width:768px) and (max-width:1024px){.main-container[_ngcontent-%COMP%]{padding-top:115px}}@media (min-width:421px) and (max-width:768px){.main-container[_ngcontent-%COMP%]{padding-top:95px}}@media (min-width:320px) and (max-width:420px){.main-container[_ngcontent-%COMP%]{padding-top:85px}}.parent-container[_ngcontent-%COMP%]{height:100%}.background-change[_ngcontent-%COMP%]{color:#fff;opacity:.4;pointer-events:none}\n/*# sourceMappingURL=app.component.css.map*/"];
export { styles as styles };
